/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MoveLabelsToSkillsInput = {|
  labelIds?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type moveLabelsToSkillsMutationVariables = {|
  input: MoveLabelsToSkillsInput
|};
export type moveLabelsToSkillsMutationResponse = {|
  +moveLabelsToSkills: ?{|
    +deletedLabelIds: ?$ReadOnlyArray<?string>
  |}
|};
export type moveLabelsToSkillsMutation = {|
  variables: moveLabelsToSkillsMutationVariables,
  response: moveLabelsToSkillsMutationResponse,
|};
*/


/*
mutation moveLabelsToSkillsMutation(
  $input: MoveLabelsToSkillsInput!
) {
  moveLabelsToSkills(input: $input) {
    deletedLabelIds
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "MoveLabelsToSkillsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MoveLabelsToSkillsPayload",
    "kind": "LinkedField",
    "name": "moveLabelsToSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moveLabelsToSkillsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moveLabelsToSkillsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "moveLabelsToSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation moveLabelsToSkillsMutation(\n  $input: MoveLabelsToSkillsInput!\n) {\n  moveLabelsToSkills(input: $input) {\n    deletedLabelIds\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c89d7ad28c0f9506cfeaac45a1521cc5';

module.exports = node;
